var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('lifecycle-stepper',{attrs:{"steps":_vm.stepDefinitions,"current-step":_vm.step}})
}
var staticRenderFns = []

export { render, staticRenderFns }